<template>
  <div class="trade-product">
    <bCardHeader :param="param" class="card-header"></bCardHeader>
    <el-row class="m0">
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <div class="trade-warming" v-if="submitTip"><i class="font-style el-icon-circle-check-outline"></i>{{
          $t('tradeProduct.submitTip') }}</div>
        <div class="trade-warming" v-if="failureTip"><img src="../../../assets/images/notice.png">{{
          $t('tradeProduct.failureTip') }}</div>
        <div class="tip" v-if="completed" test>{{ $t('tradeProduct.completedTip') }}</div>

        <el-form ref="form" v-if="subbmitedDisply" :rules="rules" :model="structuredForm" label-position="top"
          label-width="80px">
          <div class="card-base card-shadow--small trade-product-form">
            <div class="title">
              {{ $t('applyTradeAccount.confirmText') }}
            </div>
            <el-radio-group v-model="structuredForm.checkedConfirm" @change="handleInitialChoice">
              <el-radio :label="true">{{ $t('common.yes') }}</el-radio>
              <el-radio :label="false">{{ $t('common.no') }}</el-radio>
            </el-radio-group>

            <div v-if="structuredForm.checkedConfirm" class="additional-options">
              <div class="option-item">
                <div class="title">
                  {{ $t('tradeProduct.hasExchange') }}
                </div>
                <el-radio-group v-model="structuredForm.isIndustryExperience">
                  <el-radio :label="true">{{ $t('common.yes') }}</el-radio>
                  <el-radio :label="false">{{ $t('common.no') }}</el-radio>
                </el-radio-group>
                <div v-if="structuredForm.isIndustryExperience" class="option-content">
                  <!--账户选择-->
                  <el-form-item :label="$t('tradeProduct.tradingtime')" prop="deriveTradePeriod">
                    <el-date-picker style="width: 100%;" v-model="structuredForm.deriveTradePeriod" type="date"
                      :placeholder="$t('common.please_select')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('tradeProduct.relatedfinancialinstitutions')" prop="deriveTradeInstitution">
                    <el-input :placeholder="$t('common.please_input')" v-model="structuredForm.deriveTradeInstitution">
                    </el-input>
                  </el-form-item>
                  <el-form-item :label="$t('tradeProduct.producttypes')" prop="deriveTradeProductType">
                    <el-input :placeholder="$t('common.please_input')" v-model="structuredForm.deriveTradeProductType">
                    </el-input>
                  </el-form-item>
                  <el-form-item :label="$t('tradeProduct.transactionNotesTitle')" prop="deriveTradeImgs">
                    <bUploadImage ref="uploadImg" class="upload" @handleRemove="handleRemoveDeriveTradeUpload"
                      @uploadHandle="deriveTradeUpload" business='bucketBank' />
                  </el-form-item>
                </div>
              </div>
              <div class="option-item">
                <div class="title">
                  {{ $t('tradeProduct.hasWorkExperience') }}
                </div>
                <el-radio-group v-model="structuredForm.isStocks">
                  <el-radio :label="true">{{ $t('common.yes') }}</el-radio>
                  <el-radio :label="false">{{ $t('common.no') }}</el-radio>
                </el-radio-group>
                <div v-if="structuredForm.isStocks" class="option-content">
                  <!--账户选择-->
                  <el-form-item :label="$t('tradeProduct.employername')" prop="deriveExperienceName">
                    <el-input :placeholder="$t('common.please_input')" v-model="structuredForm.deriveExperienceName">
                    </el-input>
                  </el-form-item>
                  <el-form-item :label="$t('tradeProduct.position')" prop="deriveExperiencePosition">
                    <el-input :placeholder="$t('common.please_input')"
                      v-model="structuredForm.deriveExperiencePosition">
                    </el-input>
                  </el-form-item>
                  <el-form-item :label="$t('tradeProduct.yearsofemployment')" prop="deriveExperienceExperience">
                    <el-input :placeholder="$t('common.please_input')"
                      v-model="structuredForm.deriveExperienceExperience">
                    </el-input>
                  </el-form-item>
                  <el-form-item :label="$t('tradeProduct.jobDuties')" prop="deriveExperienceDuty">
                    <el-input :placeholder="$t('common.please_input')" v-model="structuredForm.deriveExperienceDuty">
                    </el-input>
                  </el-form-item>
                  <el-form-item :label="$t('tradeProduct.licenseeCardTitle')" prop="deriveExperienceImgs">
                    <bUploadImage ref="uploadImg" class="upload" @handleRemove="handleRemoveDeriveExperienceUpload"
                      @uploadHandle="deriveExperienceUpload" business='bucketBank' />
                  </el-form-item>
                </div>
              </div>
              <div class="option-item">
                <div class="title">
                  {{ $t('tradeProduct.hasTraining') }}
                </div>
                <el-radio-group v-model="structuredForm.isLearnAboutProducts">
                  <el-radio :label="true">{{ $t('common.yes') }}</el-radio>
                  <el-radio :label="false">{{ $t('common.no') }}</el-radio>
                </el-radio-group>
                <div v-if="structuredForm.isLearnAboutProducts" class="option-content">
                  <!--账户选择-->
                  <el-form-item :label="$t('tradeProduct.nameoftrainingorcourse')" prop="deriveTrainingName">
                    <el-input :placeholder="$t('common.please_input')" v-model="structuredForm.deriveTrainingName">
                    </el-input>
                  </el-form-item>
                  <el-form-item :label="$t('tradeProduct.dateoftrainingorcourse')" prop="deriveTrainingDate">
                    <el-date-picker style="width: 100%;" v-model="structuredForm.deriveTrainingDate" type="date"
                      :placeholder="$t('common.please_select')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('tradeProduct.certificateTitle')" prop="deriveTrainingImgs">
                    <bUploadImage ref="uploadImg" class="upload" @handleRemove="handleRemoveDeriveTrainingUpload"
                      @uploadHandle="deriveTrainingUpload" business='bucketBank' />
                  </el-form-item>
                </div>
              </div>
              <el-checkbox v-if="isShowDerivativesChecked" class="ed-checked-file"
                v-model="structuredForm.idNoDeriveFile">
                <span class="font-s-pf">
                  {{ $t('tradeProduct.derivativesCheckedTip') }}
                </span>
                <a :href="$t('tradeProduct.derivativesBasicLink')" target="_blank">
                  <span class="statement">{{ $t('tradeProduct.derivativesBasic') }}</span>
                </a>
                <span class="font-s-pf">
                  {{ $t('tradeProduct.derivativesCheckedTipLast') }}
                </span>
              </el-checkbox>
            </div>
            <el-form-item>
              <el-button type="primary" :disabled="!structuredForm.checkedConfirm" class="el-button-sub"
                @click="submitFn('form')">
                {{ $t('common.submit') }}
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import tradeApi from '@/api/v2/trade'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data() {
    return {
      submitTip: false,
      failureTip: false,
      completed: false,
      subbmitedDisply: false,
      rules: {
        deriveTradePeriod: [{ required: true, trigger: 'change', message: `${this.$t('common.please_input')}${this.$t('tradeProduct.tradingtime')}` }],
        deriveTradeInstitution: [{ required: true, trigger: 'change', message: `${this.$t('common.please_input')}${this.$t('tradeProduct.relatedfinancialinstitutions')}` }],
        deriveTradeProductType: [{ required: true, trigger: 'change', message: `${this.$t('common.please_input')}${this.$t('tradeProduct.producttypes')}` }],
        deriveTradeImgs: [{ required: true, trigger: 'change', message: `${this.$t('tradeProduct.transactionNotesTitle')}` }],
        deriveExperienceName: [{ required: true, trigger: 'change', message: `${this.$t('common.please_input')}${this.$t('tradeProduct.employername')}` }],
        deriveExperiencePosition: [{ required: true, trigger: 'change', message: `${this.$t('common.please_input')}${this.$t('tradeProduct.position')}` }],
        deriveExperienceExperience: [{ required: true, trigger: 'change', message: `${this.$t('common.please_input')}${this.$t('tradeProduct.yearsofemployment')}` }],
        deriveExperienceDuty: [{ required: true, trigger: 'change', message: `${this.$t('common.please_input')}${this.$t('tradeProduct.jobDuties')}` }],
        deriveExperienceImgs: [{ required: true, trigger: 'change', message: `${this.$t('tradeProduct.licenseeCardTitle')}` }],
        deriveTrainingName: [{ required: true, trigger: 'change', message: `${this.$t('common.please_input')}${this.$t('tradeProduct.nameoftrainingorcourse')}` }],
        deriveTrainingDate: [{ required: true, trigger: 'change', message: `${this.$t('common.please_input')}${this.$t('tradeProduct.dateoftrainingorcourse')}` }],
        deriveTrainingImgs: [{ required: true, trigger: 'change', message: `${this.$t('tradeProduct.certificateTitle')}` }]
      },
      structuredForm: {
        checkedConfirm: '',
        isIndustryExperience: false,
        isStocks: false,
        isLearnAboutProducts: false,
        deriveTradePeriod: '',
        deriveTradeInstitution: '',
        deriveTradeProductType: '',
        deriveTradeImgs: [],
        deriveExperienceName: '',
        deriveExperiencePosition: '',
        deriveExperienceExperience: '',
        deriveExperienceDuty: '',
        deriveExperienceImgs: [],
        deriveTrainingName: '',
        deriveTrainingDate: '',
        deriveTrainingImgs: [],
        idNoDeriveFile: false
      },
      param: {
        title: 'trade_product',
        links: [
          {
            title: 'home'
          },
          {
            title: 'my_account'
          },
          {
            title: 'trade_product'
          }
        ]
      },
      isOpenStock: false
    }
  },
  async mounted() {
    let stockList = this.getAccountInfo.filter((item) => {
      return item.type === 'STOCK'
    })
    this.isOpenStock = stockList && stockList.length > 0
    await this.getStructuredStatus()
  },
  watch: {
   'structuredForm.isIndustryExperience'(val) {
      if (val === false) {
        this.structuredForm.deriveTradePeriod = ''
        this.structuredForm.deriveTradeInstitution = ''
        this.structuredForm.deriveTradeProductType = ''
        this.structuredForm.deriveTradeImgs = []
      }
    },
    'structuredForm.isStocks'(val) {
      if (val === false) {
        this.structuredForm.deriveExperienceName = ''
        this.structuredForm.deriveExperiencePosition = ''
        this.structuredForm.deriveExperienceExperience = ''
        this.structuredForm.deriveExperienceDuty = ''
        this.structuredForm.deriveExperienceImgs = []
      }
    },
    'structuredForm.isLearnAboutProducts'(val) {
      if (val === false) {
        this.structuredForm.deriveTrainingName = ''
        this.structuredForm.deriveTrainingDate = ''
        this.structuredForm.deriveTrainingImgs = []
      }
    }
  },
  computed: {
    ...mapGetters(['getAccountInfo']),
    isShowDerivativesChecked() {
      const arr = ['isIndustryExperience', 'isStocks', 'isLearnAboutProducts']
      return !arr.some((item) => this.structuredForm[item] === true)
    }
  },
  methods: {
    getStructuredStatus() {
      tradeApi.getStructuredStatus().then(res => {
        let data = res.data ? res.data : {}
        this.isOpenStructuredProduct = data.isOpenStructuredProduct
        if (data.isOpenStructuredProduct === 'nonactivated') {
          this.subbmitedDisply = true
          this.completed = false
          return
        }
        if (data.isOpenStructuredProduct === 'submitted') {
          this.subbmitedDisply = false
          this.submitTip = true
          this.completed = false
          return
        }
        if (data.isOpenStructuredProduct === 'failure') {
          this.failureTip = true
          this.subbmitedDisply = true
          this.completed = false
          return
        }
        if (data.isOpenStructuredProduct === 'opened') {
          this.completed = true
          this.subbmitedDisply = false
        }
      })
    },
    deriveTradeUpload(imageKey) {
      this.structuredForm.deriveTradeImgs = imageKey
    },
    deriveExperienceUpload(imageKey) {
      this.structuredForm.deriveExperienceImgs = imageKey
    },
    deriveTrainingUpload(imageKey) {
      this.structuredForm.deriveTrainingImgs = imageKey
    },
    handleRemoveDeriveTradeUpload(index) {
      this.structuredForm.deriveTradeImgs.splice(index, 1)
    },
    handleRemoveDeriveExperienceUpload(index) {
      this.structuredForm.deriveExperienceImgs.splice(index, 1)
    },
    handleRemoveDeriveTrainingUpload(index) {
      this.structuredForm.deriveTrainingImgs.splice(index, 1)
    },
    handleInitialChoice(value) {
      if (value === false) {
        this.$alert(this.$t('tradeProduct.notSameInfo'), {
          confirmButtonText: this.$t('common.sureBtn')
        })
      }
    },
    submitFn(formName) {
      if (!this.isOpenStock) {
        this.openMessage('error', this.$t('tradeProduct.needCondition'))
        return
      }
      if (this.isShowDerivativesChecked && !this.structuredForm.idNoDeriveFile) {
        this.$message.error(this.$t('tradeProduct.pleaseCheckBasics'))
        return
      }
      this.$refs[formName].validate(async (valid) => {
        if (!valid) return
        let params = {
          ...this.structuredForm,
          deriveTradePeriod: moment(this.structuredForm.deriveTradePeriod).format('YYYY-MM-DD'),
          deriveTrainingDate: moment(this.structuredForm.deriveTrainingDate).format('YYYY-MM-DD')
        }
        tradeApi.setDerivativeBaseInfo(params).then(res => {
          if (res.code === 200) {
            if (this.isShowDerivativesChecked) {
              this.$router.push('/derivatives-knowledge')
            } else if (!this.isShowDerivativesChecked) {
              this.$router.push('/customer-confirmation')
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tip {
  color: #182A54;
  font-size: 18px;
  font-weight: bold;
  padding: 10px 0;

  span {
    color: #FEC000;
  }
}

.trade-warming {
  background: rgba(254, 192, 0, 0.2);
  border-radius: 6px;
  padding: 20px;
  line-height: 30px;
  word-break: break-all;

  img {
    vertical-align: middle;
    margin-right: 10px;
    width: 30px;
  }
}

.trade-product-form {
  padding: 24px;

  .title {
    margin-bottom: 18px;
  }

  .option-item {
    margin-top: 24px;
  }

  .option-content {
    margin-top: 18px;
  }

  .ed-checked-file {
    margin-top: 32px;
    margin-bottom: 32px;
  }

  .el-button {
    max-width: 250px;
  }
}

.additional-options {
  margin-top: 20px;
}
</style>
